import { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicNav from '../components/PublicNav';
import Seo from '../components/Seo';
import CorpFooter from '../components/CorpFooter';
import { LEGAL, LEGAL_SLUGS } from '../content/legal';

const OTHERS = {
  'gizlilik-politikasi': ['kullanim-kosullari', 'kvkk'],
  'kullanim-kosullari': ['gizlilik-politikasi', 'kvkk'],
  kvkk: ['gizlilik-politikasi', 'kullanim-kosullari'],
};

export default function LegalPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  const { t } = useTranslation();
  const doc = LEGAL[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!doc) return <Navigate to="/" replace />;

  return (
    <>
      <Seo title={doc.title} />
      <PublicNav />
      <main className="page-enter legal-page">
        <div className="container">
          <Link to="/" className="legal-back">← {t('nav.home', 'Ana sayfa')}</Link>
          <h1>{doc.title}</h1>
          <p className="legal-updated">Güncelleme tarihi: {doc.updated}</p>
          {doc.intro && <p className="legal-intro">{doc.intro}</p>}

          {doc.sections.map((s, i) => (
            <section className="legal-section" key={i}>
              <h2>{s.h}</h2>
              {(s.p || []).map((para, j) => <p key={j}>{para}</p>)}
              {s.list && (
                <ul>
                  {s.list.map((li, k) => <li key={k}>{li}</li>)}
                </ul>
              )}
            </section>
          ))}

          <div className="legal-nav">
            {(OTHERS[slug] || LEGAL_SLUGS.filter((x) => x !== slug)).map((o) => (
              <Link key={o} to={`/${o}`} className="btn btn-subtle btn-sm">{LEGAL[o].title}</Link>
            ))}
          </div>
        </div>
      </main>
      <CorpFooter />
    </>
  );
}
